import { render, staticRenderFns } from "./four-dots.vue?vue&type=template&id=bdfbd3de&"
import script from "./four-dots.vue?vue&type=script&lang=js&"
export * from "./four-dots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdfbd3de')) {
      api.createRecord('bdfbd3de', component.options)
    } else {
      api.reload('bdfbd3de', component.options)
    }
    module.hot.accept("./four-dots.vue?vue&type=template&id=bdfbd3de&", function () {
      api.rerender('bdfbd3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/four-dots.vue"
export default component.exports